export const colors = {
    light: '#fff',
    midLight: '#F2EEEB',
    green: '#BFDBCC',
    dark: '#585755',
    middark: '#959391',
    black: '#000000'
}